module.exports = __webpack_public_path__ + "static/media/tick.5b260683.svg";